const sorting = [
    {
        label: "Postingan terbaru",
        name: "sorting",
        value: JSON.stringify({
            sortBy: "abjad",
            orderBy: "DESC",
        }),
        id: "sorting-1",
    },
    {
        label: "Postingan terlama",
        name: "sorting",
        value: JSON.stringify({
            sortBy: "abjad",
            orderBy: "ASC",
        }),
        id: "sorting-2",
    },
];

export default sorting